import ReceiptReportBase from "./ReceiptReportBase";

export default function SlrmReceiptReportPage() {
  return <ReceiptReportBase scope="slrm" />;
}
